import { Scene, EXRCubeTexture, IDisposable } from '@babylonjs/core';
import '@babylonjs/core/Materials/Textures/Loaders/exrTextureLoader';

/** Environment for scene background. */
export class Environment implements IDisposable {
	private readonly resources: IDisposable[] = [];

	public constructor(
		private readonly scene: Scene,
	) {}

	/** Create environment from EXR file. */
	public create(): void {
		const size = 512;
		const exrPath = './assets/skybox/puresky.exr';
		const environmentTexture = new EXRCubeTexture(exrPath, this.scene, size);
		this.resources.push(environmentTexture);
		this.scene.environmentIntensity = 0;

		const skyboxMesh = this.scene.createDefaultSkybox(environmentTexture, false, size, 0);

		if (skyboxMesh) {
			skyboxMesh.scaling.x = -1;
			this.resources.push(skyboxMesh);
		}
	}

	/** @inheritdoc */
	public dispose(): void {
		this.resources.forEach(resource => resource.dispose());
	}
}
